/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { BaseToast } from 'react-native-toast-message';
import { isWeb, isNative } from '@global/screens';
import Colors from '@global/colors';
import CloseIconAsset from '@/assets/img/icons/close-grey.png';
import { translate } from '@global/translate';

let CloseIcon = CloseIconAsset;
if (isNative) {
  CloseIcon = Image.resolveAssetSource(CloseIconAsset).uri;
}

export const TOAST_PROPS = {
  visibilityTime: 2000,
  autoHide: true,
  position: 'top',
};

const baseContainerStyle = {
  maxWidth: isWeb ? '40%' : 'auto',
  minHeight: 40,
  borderLeftWidth: 2,
  borderLeftColor: Colors.blue4,
  borderRadius: 0,
  marginTop: isWeb || isNative ? 25 : 10,
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '90%',
  paddingHorizontal: 12,
  backgroundColor: Colors.blue9,
  shadowColor: '#000',
  shadowOpacity: 0.1,
  shadowRadius: 4,
  elevation: 2,
};

export const DEFAULT_STYLE_TEXT_TOAST = {
  fontSize: 13,
  fontFamily: 'figtree-regular',
  color: '#000',
  fontWeight: '400',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: isWeb ? -3 : 0,
  flexWrap: 'wrap',
};

export const DEFAULT_STYLE_TRAILING_TOAST = {
  width: 12,
  height: 12,
};

export const TOAST_CONFIG = {
  success: ({ text1, hide, props, ...rest }) => (
    <BaseToast
      {...rest}
      style={{
        ...baseContainerStyle,
        borderLeftWidth: 4,
        borderLeftColor: '#3B82F6',
        flexDirection: 'row',
        alignItems: 'center',
      }}
      contentContainerStyle={{ flex: 1, paddingHorizontal: 10 }}
      renderLeadingIcon={null}
      renderTrailingIcon={() => (
        <TouchableOpacity onPress={hide} style={{ paddingHorizontal: 8 }}>
          <Image
            source={{ uri: CloseIcon }}
            style={DEFAULT_STYLE_TRAILING_TOAST}
            resizeMode="contain"
          />
        </TouchableOpacity>
      )}
      text1={translate(text1)}
      text1Style={DEFAULT_STYLE_TEXT_TOAST}
      text2={null}
    />
  ),
  error: ({ text1, hide, props, ...rest }) => (
    <BaseToast
      {...rest}
      style={{
        ...baseContainerStyle,
        borderLeftWidth: 4,
        borderLeftColor: Colors.red1,
        backgroundColor: Colors.red4,
        flexDirection: 'row',
        alignItems: 'center',
      }}
      contentContainerStyle={{ flex: 1, paddingHorizontal: 10 }}
      renderLeadingIcon={null}
      renderTrailingIcon={() => (
        <TouchableOpacity onPress={hide} style={{ paddingHorizontal: 8 }}>
          <Image
            source={{ uri: CloseIcon }}
            style={DEFAULT_STYLE_TRAILING_TOAST}
            resizeMode="contain"
          />
        </TouchableOpacity>
      )}
      text1={translate(text1)}
      text1Style={DEFAULT_STYLE_TEXT_TOAST}
      text2={null}
      text1NumberOfLines={
        props?.text1NumberOfLines ? props?.text1NumberOfLines : 1
      }
    />
  ),
};
